/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_TrackingInputs */

const en_sync_tracking = /** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Tracking`)
};

const es_sync_tracking = /** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar Seguimiento`)
};

const fr_sync_tracking = /** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser le suivi`)
};

const de_sync_tracking = /** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking synchronisieren`)
};

const id_sync_tracking = /** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinkronisasi Pelacakan`)
};

/** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */
const ja_sync_tracking = en_sync_tracking;

/** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */
const zh_sync_tracking = en_sync_tracking;

/** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */
const ar_sync_tracking = en_sync_tracking;

/** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */
const it_sync_tracking = en_sync_tracking;

/** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */
const ru_sync_tracking = en_sync_tracking;

/** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */
const pt_sync_tracking = en_sync_tracking;

/** @type {(inputs: Sync_TrackingInputs) => LocalizedString} */
const ko_sync_tracking = en_sync_tracking;

/**
* | output |
* | --- |
* | "Sync Tracking" |
*
* @param {Sync_TrackingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sync_tracking = /** @type {((inputs?: Sync_TrackingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_TrackingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sync_tracking(inputs)
	if (locale === "es") return es_sync_tracking(inputs)
	if (locale === "fr") return fr_sync_tracking(inputs)
	if (locale === "de") return de_sync_tracking(inputs)
	if (locale === "ja") return ja_sync_tracking(inputs)
	if (locale === "zh") return zh_sync_tracking(inputs)
	if (locale === "ar") return ar_sync_tracking(inputs)
	if (locale === "id") return id_sync_tracking(inputs)
	if (locale === "it") return it_sync_tracking(inputs)
	if (locale === "ru") return ru_sync_tracking(inputs)
	if (locale === "pt") return pt_sync_tracking(inputs)
	return ko_sync_tracking(inputs)
});